import { querySelectorAll } from '../helpers'

export function initialiseFourStepSlider(selector: string) {
  const fourstep = document.querySelector(selector)
  if (fourstep) {
    const icons = fourstep.querySelector('.slider.icons')
    const descriptions = fourstep.querySelector('.slider.descriptions')
    const indicator: HTMLElement | null = fourstep.querySelector('.indicator')
    if (icons && descriptions && indicator) {
      const { lory } = window as any
      const iconsSlider = lory(icons)
      const descriptionsSlider = lory(descriptions)
      let isTiny = window.innerWidth < 640
      let iconsSliding = false
      let descriptionsSliding = false

      const selectIconSlide = (index: number) => {
        if (!iconsSliding && iconsSlider.returnIndex() !== index) {
          iconsSlider.slideTo(index)
        }
      }

      const selectDescriptionSlide = (index: number) => {
        if (
          !descriptionsSliding &&
          descriptionsSlider.returnIndex() !== index
        ) {
          descriptionsSlider.slideTo(index)
        }
      }

      icons.addEventListener(
        'after.lory.slide',
        ({ detail: { currentSlide } }: any) => {
          iconsSliding = false
          if (!isTiny) {
            indicator.style.transform = `translateX(${currentSlide * 100}%)`
          }
        }
      )

      descriptions.addEventListener(
        'after.lory.slide',
        ({ detail: { currentSlide } }: any) => {
          if (!isTiny) {
            descriptionsSliding = true
            selectIconSlide(currentSlide)
          }
          descriptionsSliding = false
        }
      )

      icons.addEventListener(
        'before.lory.slide',
        ({ detail: { nextSlide } }: any) => {
          if (isTiny) {
            iconsSliding = true
            selectDescriptionSlide(nextSlide)
          }
        }
      )

      descriptions.addEventListener(
        'before.lory.slide',
        ({ detail: { nextSlide } }: any) => {
          if (isTiny) {
            descriptionsSliding = true
            selectIconSlide(nextSlide)
          }
        }
      )

      querySelectorAll('.icon').forEach((icon: Element, index) => {
        icon.addEventListener('click', () => {
          if (!isTiny) {
            iconsSlider.slideTo(index)
            descriptionsSlider.slideTo(index)
          }
        })
      })

      window.addEventListener('resize', () => {
        const newSize = window.innerWidth < 640
        if (isTiny !== newSize) {
          isTiny = newSize
          indicator.style.transform = 'translateX(0)'
        }
      })
    }
  }
}
